export default __webpack_public_path__ + "static/media/caret-up.5d1d932b.svg";